export const timeScale = {
  type: "time" as const,
  time: {
    tooltipFormat: "MMM dd, yyy HH:mm:ss",
  },
  ticks: {
    callback: function (value: string | number, index: number, ticks: any) {
      const date = new Date(value);
      return date.toLocaleDateString();
    },
  },
  title: {
    display: true,
    text: "Date",
    font: { size: 20 },
  },
};

export const depthToGroundWaterScale = {
  ticks: {
    callback: function (value: string | number, index: number, ticks: any) {
      return `${value}'`;
    },
  },
  title: { display: true, text: "Groundwater depth below surface (ft)", font: { size: 20 } },
  position: "left" as const,
  reverse: true,
};
